function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  fontFamily: "Ionicons",
  fontSize: 50,
  fontWeight: 400
}, React.createElement("g", {
  id: "Shopping-Cart",
  transform: "translate(-43.000000, -206.000000)",
  fill: "#000000"
}, React.createElement("g", {
  id: "Cart-Title",
  transform: "translate(43.000000, 200.000000)"
}, React.createElement("text", {
  id: "ion-ios-cart-outline---Ionicons"
}, React.createElement("tspan", {
  x: 0,
  y: 44
}, "\uF3F7")))));

var SvgCartLarge = function SvgCartLarge(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCartLarge, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cartLarge.58c53cdf.svg";
export { ForwardRef as ReactComponent };